(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleDialogController', MonitoringRuleDialogController);

    MonitoringRuleDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'MonitoringRule', 'Agence', 'User', '$filter'];

    function MonitoringRuleDialogController ($scope, $stateParams, $uibModalInstance, entity, MonitoringRule,Agence, User, $filter) {
        var vm = this;
        vm.monitoringRule = entity;
        // Une règle en cours d'édition doit conserver son type déjà configuré.
        vm.isNew = !entity.$promise && !entity.id;
        vm.onlyUnconfigured = vm.isNew;
        vm.listTypeRules = [];
        vm.typesLoaded = false;
        vm.typeRulesLoadError = false;
        vm.formatTypeRule = formatTypeRule;

        vm.agences = Agence.query();
        vm.users = User.query({ page: 0, size: 200, activated: true, sort: 'login,asc' });
        vm.formatUser = formatUser;
        ensureAdditionalRecipients();
        
        MonitoringRule.queryTypeRules({}, function(result) {
        	vm.listTypeRules =  result;
            vm.typesLoaded = true;
            vm.availableTypeCount = result.filter(function(type) { return !type.configuredCount; }).length;
        	
            // Extraire les groupes uniques
            var uniqueGroups = {};
        	vm.groups = [];
        	vm.listTypeRules.forEach(function (rule) {
        	    if (!uniqueGroups[rule.group]) {
        	        uniqueGroups[rule.group] = true;
        	        vm.groups.push(rule.group);
        	    }
        	});
            
            
         	if(vm.monitoringRule && vm.monitoringRule.$promise){
        		vm.monitoringRule.$promise.then(function(value) {
                    ensureAdditionalRecipients();
        			
        			function findTypeRuleFunction(item, index, array) {
        				if(item.name== vm.monitoringRule.typeRule){
       					 	vm.monitoringRule.typeRule = item;
        				}
        			}
        			
        			vm.listTypeRules.forEach(findTypeRuleFunction);
    
    	    	});	
            }
            // Initialiser les règles filtrées
            vm.updateFilteredTypeRules();
        }, function() {
            vm.typeRulesLoadError = true;
        });
        
        
        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:monitoringRuleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            vm.monitoringRule.additionalRecipientUserIds = [];
            angular.forEach(vm.monitoringRule.additionalRecipients, function(user) {
                if (user && user.id) {
                    vm.monitoringRule.additionalRecipientUserIds.push(user.id);
                }
            });
            // Garder l'objet sélectionné si l'enregistrement échoue et doit être réessayé.
            var payload = angular.copy(vm.monitoringRule);
            payload.typeRule = vm.monitoringRule.typeRule.name;
            if (vm.monitoringRule.id !== null) {
                MonitoringRule.update(payload, onSaveSuccess, onSaveError);
            } else {
                MonitoringRule.save(payload, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        
        


        // Valeur par défaut du groupe sélectionné (affiche tout au départ)
        vm.selectedGroup = '';

        // Fonction pour filtrer la liste selon le groupe sélectionné
        vm.getFilteredTypeRules = function () {
            return vm.listTypeRules.filter(function (rule) {
                return (!vm.selectedGroup || rule.group === vm.selectedGroup)
                    && (!vm.onlyUnconfigured || !rule.configuredCount);
            });
        };

        // Mettre à jour les règles filtrées
        vm.updateFilteredTypeRules = function () {
            vm.filteredTypeRules = vm.getFilteredTypeRules();
            // Ne pas enregistrer par mégarde un type masqué par un nouveau filtre.
            if (vm.isNew && vm.monitoringRule.typeRule && !vm.filteredTypeRules.some(function(type) {
                return type.name === vm.monitoringRule.typeRule.name;
            })) {
                vm.monitoringRule.typeRule = null;
            }
        };

        function formatTypeRule(type) {
            var label = $filter('translate')('wamasysApp.monitoringRule.typeEnum.' + type.name);
            if (type.configuredCount) {
                label += ' — ' + $filter('translate')('wamasysApp.monitoringRule.availability.configured', {count: type.configuredCount});
            }
            return label;
        }

        function ensureAdditionalRecipients() {
            if (vm.monitoringRule && !vm.monitoringRule.additionalRecipients) {
                vm.monitoringRule.additionalRecipients = [];
            }
        }

        function formatUser(user) {
            if (!user) {
                return '';
            }
            var name = trimText((user.firstName || '') + ' ' + (user.lastName || ''));
            if (name && user.email) {
                return name + ' (' + user.email + ')';
            }
            return name || user.email || user.login;
        }

        function trimText(value) {
            return (value || '').replace(/^\s+|\s+$/g, '');
        }



    }
})();
